const lang = {
    actionButton: {
        confirm: '확인',
        cancel: '취소',
    },
};
export default lang;
